import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Pill } from '@shared/components/pill';
import { NumberField } from '@shared/data/entity/fields/NumberField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: NumberField;
  style: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
}

const numberStyles: StyleProp<ViewStyle> = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginLeft: -grid(0.5),
};

export function NumberCollectionViewField({ field, style, textStyle }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[numberStyles, style]}>
      <Pill sections={[field.formattedValue]} maxWidth={grid(32)} textStyle={textStyle} />
    </CardCollectionViewFieldContainer>
  );
}
